export enum Routes {
  ROOT = '',
  ID = ':id',
  AUTH = 'auth',
  REGISTER = 'register',
  LOGIN = 'login',
  RECOVERY = 'recovery',
  TELEGRAM = 'telegram',
  PASSWORD = 'password',
  CODE = 'code',
  SMS = 'sms',
  EMAIL = 'email',
  SELECT = 'select',
  PASSPORT = 'passport',
  WHATSAPP = 'whatsapp',
  PROJECT = 'project',
  ABOUT = 'about',
  DASHBOARD = 'dashboard',
  SHARE = 'share',
  DEVELOPMENT = 'development',
  NEWS = 'news',
  PAYMENT = 'payment',
  BALANCE = 'balance',
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  TRANSFER = 'transfer',
  MY = 'my',
  SETTING = 'setting',
  PROFILE = 'profile',
  TRANSACTION = 'transaction',
  INSTALLMENT = 'installment',
  SUCCESS = 'success',
  REJECT = 'reject',
  REFERRAL = 'referral',
  PARTNER = 'partner',
  HISTORY = 'history',
  LIST = 'list',
  TREE = 'tree',
  MAP = 'map',
  SECURITY = 'security',
  LANGUAGE = 'language',
  PHONE = 'phone',
  SUPPORT = 'support',
  CHAT = 'chat',
  COMPANY = 'company',
  BUILDINGS = 'buildings',
  REPORT = 'report',
  CALCULATOR = 'calculator',
  MONEYBOX = 'piggy',
  TASK = 'task',
  HEIR = 'heir',
  NFT = 'nft',
  TOP = 'top',
  NOTIFICATION = 'notification'
}
